import { skipToken } from '@reduxjs/toolkit/query/react';
import type { Cutscene } from '@sorrem/shared';
import { useGetCutsceneQuery } from '@sorrem-client/ui/store';
import { useCurrentCharacterArgs } from './use-current-character-id';

export interface CutsceneState {
    cutscene: Cutscene | null;
    isLoading: boolean;
    isError: boolean;
}

/**
 * One cutscene's content, for the current character: served by
 * `GET .../characters/:characterId/cutscenes/:cutsceneId`, which only serves
 * one the character has seen or is about to see.
 */
export function useCutscene(cutsceneId: string): CutsceneState {
    const args = useCurrentCharacterArgs();
    const { data, isLoading, isError } = useGetCutsceneQuery(args === skipToken ? skipToken : { ...args, cutsceneId });
    return { cutscene: data ?? null, isLoading, isError };
}
